import { useEffect, useState } from 'react';
import useSavedContacts from '@hooks/useSavedContacts';

const useSavedContactsActive = (options, includeInactive) => {
    const [savedContacts, setSavedContacts] = useState();
    const { data, ...rest } = useSavedContacts({ fields: 'recordId status', options });

    useEffect(() => {
        if (!data) {
            return;
        }

        setSavedContacts(data.contacts.filter(c => (includeInactive ? true : c.status === 'Active')));
    }, [data, includeInactive]);

    return { data: savedContacts, ...rest };
};

export default useSavedContactsActive;
